import { render } from "./AttributeParamsMouduleSimple.vue?vue&type=template&id=ea4713e4&scoped=true"
import script from "./AttributeParamsMouduleSimple.vue?vue&type=script&lang=js"
export * from "./AttributeParamsMouduleSimple.vue?vue&type=script&lang=js"

import "./AttributeParamsMouduleSimple.vue?vue&type=style&index=0&id=ea4713e4&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea4713e4"]])

export default __exports__